import React from "react";

import Guesser from "../components/Guesser";
import ClueGiver from "../components/ClueGiver";

const PreGuess = ({ roomId, isGuesser, mobile_app, currentGuesser, preguess_params }) => {
  return isGuesser ? (
    <Guesser roomId={roomId} mobile_app={mobile_app} preguess_params={preguess_params} />
  ) : (
    <ClueGiver
      mobile_app={mobile_app}
      currentGuesser={currentGuesser}
      preguess_params={preguess_params}
    />
  );
};

export default PreGuess;
